<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ getModalCardTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <!-- Control panel -->
        <template>
          <v-row>
            <v-col cols="12">
                <el-button
                v-if="canEditRepresenters"
                class="mb-3"
                small
                color="primary"
                icon="pridėti"
                :title="$t('Pridėti atstovą')"
                :loading="loading"
                @click.native.stop="newRepresenter()"
              />
            </v-col>
          </v-row>
        </template>

        <v-card class="mb-2 py-4">
          <v-card-text>
            <!-- Signatures list -->
            <template v-if="signatures.length > 0 && !signatureLoading">
              <v-row v-for="(signature, index) in signatures" :key="signature.amn_id" style="border-bottom: 1px solid grey">
                <v-col cols="12">
                  <single-signature 
                    :signature="signature" 
                    :index="index" 
                    :length="signatures.length"
                    :canEditRepresenters="canEditRepresenters"
                    @deleteSignature="deleteSignature(index)"
                    @move="move"
                    @clickedCheckBox="clickedCheckBox"
                    @inputChange="inputChange"
                  />
                </v-col>
              </v-row>
            </template>

            <!-- EMPTY list -->
            <template v-else>
              <div>{{$t('Atstovų nėra')}}</div>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          color="danger"
          @click.native="cancel()"
          :loading="loading || submitLoading"
          title="Atšaukti"
        />
        <el-button
          color="primary"
          @click.native.stop="submit()"
          :loading="loading || submitLoading"
          title="Išsaugoti"
        />
      </v-card-actions>
    </v-card>

    <!-- modal  -->
    <modal-add-person
      v-if="showAddPerson"
      v-model="showAddPerson"
      modalType="jur_representers"
      :dataType="dataType"
      :parentSignature="parentSignature"
      @addPersonData="addPerson"
    />
    <modal-delete
      title="Įrašo šalinimas"
      :text="`Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      @confirmDelete="confirmDelete"
    />
  </v-dialog>
</template>

<script>
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalDelete from '@/components/modals/ModalDelete'
import SingleSignature from '@/components/signatures/SingleSignature'

export default {
  name: 'ModalSignatureOrder',
  components: {
    ModalAddPerson,
    ModalDelete,
    SingleSignature
  },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    dataType: { type: String, default: 'jur_representer_against_parent' },
    value: Boolean,
    loading: Boolean,
    inJournalId: [String, Number],
    selectedSignature: Object,
    modalCardTitle: [String],
    additionalData: [Object, Array],
    selectedSignatureId: [String, Number],
    allowDelete: [Boolean],
    turnOnAddrepresenter: [Boolean],
    emitOnSave: [Boolean],
    onlyOrder:[Boolean],
    signaturesFromParent: [Array],
    selectedFromParent: [Object],
  },
  data() {
    return {
      signatureLoading: false,
      submitLoading: false,
      showAddPerson: false,
      signatures: [],
      contentloading: true,
      showDelete: false,
      allowAddrepresenter: false,
      signatureId: null,
      parentSignature: {},
    }
  },
  computed: {
    canEditRepresenters() {
      return (this.allowAddrepresenter || this.turnOnAddrepresenter) && this.onlyOrder != true
    },
    getModalCardTitle() {
      return this.modalCardTitle || this.$t('Pasirašančiųjų eilė ir kontaktai')
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    selectedSignatureId: {
      immediate: true,
      handler(val, oldVal) {
        this.getData()
      }
    },
    onlyOrder: {
      immediate: true,
      handler(val, oldVal) {
        this.getData()
      }
    },
    selectedFromParent: {
      immediate: true,
      handler(val, oldVal) {
        this.parentSignature = this.selectedFromParent
      }
    }
  },
  methods: {
    clickedCheckBox(index, property, val) {
      this.signatureLoading =  true
      if (this.signatures[index]) {
        this.$set(this.signatures[index], property, val);
      }

      this.$nextTick(() => {
        this.signatureLoading = false
      })
    },
    inputChange() {
      this.signatureLoading =  true
      this.$nextTick(() => {
        this.signatureLoading = false
      })
    },
    deleteSignature(index) {
      this.indexToDelete = index
      this.showDelete = true
    },
    confirmDelete() {
      this.signatures.splice(this.indexToDelete, 1)
      this.showDelete = false
    },
    addPerson(item) {
      if (this.signatures.filter((signature) => signature.amn_id == item.amn_id).length > 0) {
          return this.$root.$emit('DATA_ERROR_CODE', '000026')
      }
      item.canDelete = true
      item.email_enabled = false
      item.sms_enabled = false
      item.email_address = null
      item.phone_number = null
      item.phone_number_prepend = '370'
      item.textToShow = ' '
      this.signatures.push(item)
      this.showAddPerson = false
    },
    newRepresenter() {
      this.modalType = 'jur_representers'

      this.showAddPerson = true
    },
    showSMSInfo(item){
      if(item.phone_number_prepend != '' && (item.phone_number_prepend != '+370' && item.phone_number_prepend != '370') && item.phone_number_prepend != null) {
        return this.$t('Informuojame, kad trumpieji pranešimai (SMS) siunčiami tik Lietuvoje veikiančių mobiliojo ryšio operatorių registruotiems telefono numeriams.')
      } else {
        return ''
      }
    },
    getData() {
      if (this.onlyOrder) {
        this.signatures = this.signaturesFromParent
        this.allowAddrepresenter = false
        this.signatureId = null
        this.parentSignature = {}
      } else {
        this.contentloading = true
        let url = '';
        if (this.inJournalId) {
          url = `in-journals/${this.inJournalId}/mySignatures`
        } else if (this.selectedSignatureId) {
          url = `in-journals/${this.selectedSignatureId}/childSignatures`
        }
    
        if (url) {
          this.$axios
            .get(url)
            .then((res) => {
              this.signatures = res.data.signatures
              this.signatures.map((signature) => {
                signature.phone_number_prepend = signature.phone_number_prepend || '+370'
              })
              this.allowAddrepresenter = res.data.canAddRepresenter
              this.signatureId = res.data.signatureId
              this.parentSignature = res.data.selectedSignature
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.contentloading = false
            })
        }
      }
    },
    saveOrder(){
      this.$validator.validateAll().then((res) => {
        if (res){
          if (this.emitOnSave) {
            this.$emit('saveEvent', this.signatures)
            this.closeModal()
            return;
          }
          let formData = {signatures: []};
  
          let url = '';
          // if (this.inJournalId) {
          //   url = `in-journals/${this.inJournalId}/storeMySignatures`
          // } else 
          if (this.selectedSignatureId) {
            url = `in-journals/${this.selectedSignatureId}/storeChildSignatures`
          } else {
            url = `in-journals/${this.signatureId}/storeChildSignatures`
          }
  
          this.signatures.map((signature, index) => {
            formData.signatures.push({
                id: signature.id,
                amn_id: signature.amn_id,
                order_no: index+1,
                email_enabled: signature.email_enabled,
                sms_enabled: signature.sms_enabled,
                email_address: signature.email_address,
                phone_number: signature.phone_number,
                phone_number_prepend: signature.phone_number_prepend
              })
          });
          this.submitLoading = true;
          this.$axios
            .post(url, formData)
            .catch((err) => {this.$root.$emit('DATA_ERROR', err)})
            .finally(() => {
              this.submitLoading = false;
              if (this.inJournalId) {
                  this.contentloading = false
                  location.reload()
              } else {
                this.$root.$emit('DATA_OK_CODE', '000110')
                location.reload()
              }
              this.closeModal()
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    move(from, to){
      this.signatures.splice(to, 0, this.signatures.splice(from, 1)[0]);
    },
    submit() {
      this.saveOrder()
    },
    cancel() {
      this.closeModal()
    },
    closeModal() {
      if (!this.emitOnSave) {
        this.signatures = []
      }
      this.showModal = false
      this.$emit('closeModal')
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
